"use client";
import { ProcessedCourse } from "@/common/course/types";
import ExecCourseAbout from "@/components/ExecEd/components/ExecCourseAbout";
import StickyNav from "@/components/ExecEd/components/ExecEdStickyNav";
import getCoursePaymentOption from "@/lib/course/utils/getCoursePaymentOption";
import { addQueryParamsToUrl } from "@/lib/course/utils/addQueryParamsToUrl";
import { getCourseSubject } from "@/utils/tagular/helpers";
import { execEdBTFLinks } from "./constants";

import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import { ExecEdDetailPageTestResult } from "@/monarch/rules/execEdDetailPageTest/types";
import useTranslations from "@/i18n/useTranslations";
import type { ExecEdBTFSectionKey } from "./types";

export default function ExecEdBTFLegacy({
  course,
}: {
  course: ProcessedCourse;
}) {
  const t = useTranslations("Course");
  const titleOverride = `${course.partners[0]?.name}: ${course.productName}`;

  const paymentOption = getCoursePaymentOption(course);
  const { externalIdentifier, organicUrl } =
    course.additionalMetadata?.at(0) || {};
  const cartUrl = `https://getsmarter.com/titan/api/v1/cart/add_item/${externalIdentifier}`;

  let marketingType =
    course.additionalMetadata?.[0].externalCourseMarketingType ?? "";
  const isSprint = marketingType === "sprint";

  const enrollmentURL = addQueryParamsToUrl({
    url: cartUrl,
    includeUtmCampaign: false,
    organicUrl: organicUrl,
    extraQueryParams: {
      external_link: true,
    },
  });
  return (
    <MonarchDataConsumer<ExecEdDetailPageTestResult>
      experimentKey="useExecEdDetailPageTest"
      render={({ data }) => {
        return (
          <>
            <StickyNav
              links={execEdBTFLinks.map((link) => ({
                ...link,
                label: t(
                  link.key as Exclude<ExecEdBTFSectionKey, "promoBanner">,
                ),
              }))}
              courseRun={isSprint ? course.activeCourseRun : null}
              requestMoreInfoButton={{
                label: data?.stickyBannerCta?.ctaText ?? t("requestMoreInfo"),
                path: "#brochure",
              }}
              marketingType={marketingType}
              enrollButtonLink={enrollmentURL}
            />
            <ExecCourseAbout
              course={course}
              paymentOption={paymentOption}
              marketingType={marketingType}
              enrollButtonLink={enrollmentURL}
              title={titleOverride}
              subject={getCourseSubject(course)}
              expandMobileAccordianByDefault={
                data?.expandMobileAccordianByDefault
              }
              showCourseSnapshot={data?.showCourseSnapshot}
            />
          </>
        );
      }}
    />
  );
}
